import { ResponseBase } from '@/services/types'
import { GetProductsRes, Product, getProducts, getProductDetails, ShopParams } from './product'
import { SubcategoryRes, getSubcategories } from './subcategories'
import { GetCategoriesRes, getCategories } from './categories'
import { rateProduct } from './rate'

type UseProductApi = () => {
  getCategories: () => Promise<ResponseBase<GetCategoriesRes>>
  getSubcategories: () => Promise<ResponseBase<SubcategoryRes>>
  getProducts: (params: ShopParams) => Promise<ResponseBase<GetProductsRes>>
  getProductDetails: (id: number | string | string[] | undefined) => Promise<ResponseBase<Product>>
  rateProduct: (id: number, point: string) => Promise<string>
}

export const useProductApi: UseProductApi = () => {
  return {
    getCategories: async () => {
      return await getCategories()
    },
    getProducts: async (params) => {
      return await getProducts(params)
    },
    getProductDetails: async (id: number | string | string[] | undefined) => {
      return await getProductDetails(id)
    },
    getSubcategories: async () => {
      return await getSubcategories()
    },
    rateProduct: async (id, point) => {
      return await rateProduct(id, point)
    }
  }
}
